import React, { useCallback, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component'
import ContractsFilters from '../components/UI/contracts/table/ContractsFilters';
import { Contract } from '../types/contract';
import { centsClient } from '../api/cents/clients/cents-client';
import useFilters from '../hooks/useFilters';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import useContractsTableFields from '../hooks/contracts/table-fields/ContractsTableFieldsHook';
import { TableField } from '../types/table-field';
import TableStructure from '../components/UI/common/table/TableStructure';
import ContractsTableBody from '../components/UI/contracts/table/ContractsTableBody';
import { translations } from '../utils/translations/translations-manager';

const ContractsPage: React.FC = () => {
  const charity = useSelector((state: RootState) => state.auth.charity)
  if (!charity) {
    throw new Error("Charity not found") // TODO Is this right?
  }
  const charityName = useSelector((state: RootState) => state.auth.charity?.name)
  const [tableData, setTableData] = useState<Contract[]>([])
  const [page, setPage] = useState<number>(1)
  const [hasMore, setHasMore] = useState<boolean>(true)
  const [filterRequest, setFilterRequest] = useState<boolean>(true)
  const [appliedFilters, setAppliedFilters] = useState<Record<string, any>>({})
  const { getActiveFilters } = useFilters()
  const { getCustomFields, getStandardFields } = useContractsTableFields()
  const [fields, setFields] = useState<TableField[]>([])

  const fetchContracts = useCallback(async (reset = false) => {
    const filters = getActiveFilters()
    const newPage = reset ? 1 : page
    const data = await centsClient.contracts.getContracts(charity._id, { ...filters }, newPage, 50)

    if (reset) {
      setTableData([])
      setTableData(data)
    } else {
      setTableData((prev) => [...prev, ...data])
    }

    setHasMore(data.length === 50)
    setPage(newPage + 1)
    setAppliedFilters(filters)
  }, [getActiveFilters, page, charity._id])

  useEffect(() => {
    if (filterRequest === true) {
      setPage(1)
      setHasMore(true)
      fetchContracts(filterRequest)
      setFilterRequest(false)
    }
  }, [filterRequest])

  useEffect(() => {
    const getAllFields = async () => {
      const [customFields, standardFields] = await Promise.all([
        getCustomFields(charity),
        getStandardFields(charity)
      ])
      
      setFields([...standardFields, ...customFields])
    }
    
    getAllFields()
  },[])

  return (
    <div className={`page contracts w-full h-fit flex flex-col justify-start oveflow-y-hidden`}>
      <div className={`contracts-table p-5 rounded-2xl bg-cents-white`}>
        <div className="contracts-header h-fit flex flex-col mb-5">
          <div className="title whitespace-nowrap mb-5">
            <p>{charityName} /</p>
            <h2 className='text-2xl font-semibold'>{translations.texts.donations.toString()}</h2>
          </div>
          <ContractsFilters
            filterTable={() => setFilterRequest(true)}
            appliedFilters={appliedFilters}
          />
          {/*<TableRewiev tableData={tableData} />*/}
        </div>
        <div className="paginated-table">
          <InfiniteScroll
            next={() => fetchContracts()}
            hasMore={hasMore}
            loader={<h4 className='mt-4 text-cents-purple-light italic font-medium'>{translations.texts.loading.toString()}...</h4>}
            dataLength={tableData.length}>
            <TableStructure tableFields={fields}>
              <ContractsTableBody tableData={tableData} tableFields={fields} />
            </TableStructure>
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
};

export default ContractsPage;
